import React from 'react';

export const TimeOfDayIconGray = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 59 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="0" width="59" height="32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0344 17.9893C34.002 17.9893 38.0291 13.9623 38.0291 8.99467C38.0291 7.73777 37.7713 6.54109 37.3057 5.45461H58.0682V32.0001H0V5.45461H20.7632C20.2975 6.54109 20.0397 7.73777 20.0397 8.99467C20.0397 13.9623 24.0668 17.9893 29.0344 17.9893ZM20.7632 5.45461C22.1378 2.24702 25.3237 0 29.0344 0C32.7451 0 35.931 2.24702 37.3057 5.45461H20.7632Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M1.65918 30.2631C19.1572 30.2631 13.9731 10.3696 28.7615 10.3696C43.5499 10.3696 38.6921 30.2631 55.8639 30.2631"
        stroke="#BFBFBF"
        strokeDasharray="2"
      />
      <path
        d="M55.8086 30.2631C71.841 30.2631 72.6894 10.3696 82.911 10.3696C93.1325 10.3696 95.1458 30.2631 110.013 30.2631"
        stroke="#979797"
        strokeDasharray="2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3882 21.7589C20.1752 16.5986 21.8954 11.3564 28.8953 11.3564C35.8952 11.3564 37.5998 16.5986 40.4826 21.8408L17.3882 21.7589Z"
      fill="#F6F6F6"
    />
    <path d="M1.91169 21.4963H55.5794" stroke="#BFBFBF" strokeLinecap="square" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.806 16.8174L28.0118 14.2404C27.3454 14.0951 26.728 13.8211 26.1863 13.4462L25.806 16.8174ZM24.046 10.134C24.168 10.805 24.4203 11.4316 24.7761 11.986L21.3938 12.2484L24.046 10.134ZM24.8757 6.27814C24.5008 6.81975 24.2268 7.43712 24.0814 8.1035L21.5046 5.8978L24.8757 6.27814ZM28.1881 4.13793C27.517 4.25989 26.8904 4.51215 26.336 4.86792L26.0736 1.48561L28.1881 4.13793ZM32.0438 4.96774C31.5022 4.59278 30.8848 4.31876 30.2184 4.17342L32.4242 1.59646L32.0438 4.96774ZM34.1839 8.28004C34.0619 7.60894 33.8096 6.98231 33.4538 6.4279L36.8364 6.16541L34.1839 8.28004ZM33.3542 12.1357C33.7291 11.594 34.0031 10.9766 34.1485 10.3101L36.7255 12.516L33.3542 12.1357ZM32.1566 16.9282L31.8941 13.5457C31.3397 13.9015 30.7131 14.1538 30.042 14.2758L32.1566 16.9282ZM29.0404 13.4872C31.4045 13.5284 33.3545 11.6454 33.3958 9.28123C33.437 6.91709 31.554 4.96712 29.1898 4.92586C26.8257 4.88459 24.8757 6.76765 24.8345 9.13179C24.7932 11.4959 26.6763 13.4459 29.0404 13.4872Z"
      fill="#EBEBEB"
    />
  </svg>
);
